// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/clock.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'clock',
  version: 'outline',
  paths: [
    {
      d: 'M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z',
    },
  ],
}
